<template>
  <div>
    <div class="relative">
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FLINTLayout'
}
</script>
